import { Button } from 'components/admin/ui';
import { Eye } from 'ethena-icons';
import { useState } from 'react';
import css from './ImpersonatedUserView.module.scss';
import { ImpersonationToolbar } from './ImpersonationToolbar';
import { useImpersonationContext } from './context';

export const ImpersonatedUserView = () => {
  const { endImpersonation, impersonatedUser } = useImpersonationContext();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleEndImpersonation = async () => {
    setIsLoading(true);
    await endImpersonation();
  };

  return (
    <>
      <ImpersonationToolbar.Content>
        <Eye aria-hidden="true" height={24} width={24} />
        <div className={css.user}>
          <div className={css.name}>
            {impersonatedUser.name} (ID: {impersonatedUser.id})
          </div>
          <div className={css.company}>
            <span>{impersonatedUser.primaryEmail}</span>
            <span>|</span>
            <span>
              {impersonatedUser.companyName} (ID: {impersonatedUser.companyId})
            </span>
          </div>
        </div>
      </ImpersonationToolbar.Content>

      <ImpersonationToolbar.Actions>
        <Button isLoading={isLoading} onClick={handleEndImpersonation}>
          End Impersonation
        </Button>
      </ImpersonationToolbar.Actions>
    </>
  );
};
